<script lang="ts">
  import { onMount } from 'svelte';
  import { bildebanken } from './bildebanken.svelte';

  let dialog = $state<HTMLDialogElement>();
  let mountEl = $state<HTMLDivElement>();

  onMount(() => {
    return () => bildebanken.destroy();
  });

  $effect(() => {
    if (!dialog) return;
    if (bildebanken.isOpen && !dialog.open && mountEl) {
      bildebanken.init(mountEl);
      dialog.showModal();
    } else if (!bildebanken.isOpen && dialog.open) {
      dialog.close();
    }
  });
</script>

<dialog bind:this={dialog} onclose={() => bildebanken.close()}>
  <div bind:this={mountEl} class="bb-mount"></div>
</dialog>

<style>
  dialog {
    box-sizing: border-box;
    width: 90vw;
    max-width: 1200px;
    height: 80vh;
    padding: 0;
    border: none;
    border-radius: 6px;
    overflow: hidden;
  }

  dialog::backdrop {
    background: rgba(0, 0, 0, 0.4);
  }

  .bb-mount {
    width: 100%;
    height: 100%;
  }
</style>
